import { inventoryCsv } from './inventoryData';
import type { IInventoryItem, IInventoryResponseBody } from 'src/api/getInventory';
import type { IAsset, MenuItemsProp } from 'src/helpers/menus/menus.types';
import type { ISection, TMenuItemType } from 'src/types/menu.types';
import type { IVenueOpeningTimesRequest } from 'src/api/createVenueOpeningTimes/types';
import type { IMenuItemsResponseBody } from 'src/api/getMenuItems/types';
import { IRangesResponseBody } from 'src/api/getRanges/types';
import { IGetPriceBandsResponseBody } from 'src/api/getPriceBands';
import { SnackbarStatus } from '@weareopenr/component-library';

export const inventoryItem: IInventoryItem = {
  recipe_id: 'uuid',
  name: 'Vegetable Gyoza',
  type: 'RECIPE',
  description: 'Vegetable Gyoza',
  is_vegan: false,
  is_vegetarian: false,
  contains_alcohol: false,
  nutritional_information: [],
  allergens_information: [],
  create_date: new Date('2022-03-30 12:35:06.690682'),
  update_date: new Date('2022-03-30 12:35:06.690682'),
  create_user_id: 'uid',
  update_user_id: 'uid',
};

export const asset: IAsset = {
  asset_id: 'g2gh32iherf897fdjh354',
  name: 'burger image',
  asset_variants: [
    {
      url: 'https://azzurri-product-images-dev.s3.eu-west-1.amazonaws.com/d9551a60-0a6a-4eb5-9c80-ee0851767cff',
      asset_id: 'g2gh32iherf897fdjh354',
    },
  ],
};

// DO NOT USE - to be deleted

export const burger: MenuItemsProp = {
  item_id: 'burger',
  name: 'Burger',
  description: 'very yummy',
  price: 1.5,
  assets: [asset],
  plu: '1234',
  recipes: [inventoryItem],
  tax_rate: 20,
  type: 'STANDARD',
  create_date: new Date('2022-04-20T14:32:02.759Z'),
  update_date: new Date('2022-04-20T14:32:02.759Z'),
  create_user_id: '00uia83yqD9COeLn6696',
  update_user_id: '00uia83yqD9COeLn6696',
  modifier_groups: [],
};

export const hotdog: MenuItemsProp = {
  item_id: 'hotdog',
  name: 'Hot Dog',
  description: 'very yummy',
  price: 1.5,
  assets: [asset],
  plu: '1234',
  recipes: [inventoryItem],
  tax_rate: 20,
  type: 'STANDARD',
  create_date: new Date('2022-04-20T14:40:02.891Z'),
  update_date: new Date('2022-04-20T14:40:02.891Z'),
  create_user_id: '00uia83yqD9COeLn6696',
  update_user_id: '00uia83yqD9COeLn6696',
};

export const ketchup: MenuItemsProp = { ...hotdog, ...{ item_id: 'ketchup', name: 'Ketchup', type: 'MODIFIER' } };

export const pizza: MenuItemsProp = { ...hotdog, ...{ item_id: 'pizza', name: 'Pizza' } };

export const menuItems = [burger, hotdog, ketchup, pizza];

export const menu = {
  menu_id: 'summer-menu',
  name: 'Summer Menu',
  consumer_name: 'New Menu',
  create_date: new Date('2022-01-30 12:35:06.690682'),
  update_date: new Date('2022-01-30 12:35:06.690682'),
  items: menuItems,
  assets: [asset],
  sections: [
    {
      section_id: 'new-section',
      name: 'new section',
      items: [ketchup],
      create_date: new Date('2022-03-30 12:35:06.690682'),
      update_date: new Date('2022-03-30 12:35:06.690682'),
      create_user_id: 'abcde',
      update_user_id: 'abcde',
    },
  ],
};

export const duplicatedMenuResponse = {
  type: 'menu',
  data: [
    {
      menu_id: '890',
      name: 'Test (Copy)',
      consumer_name: 'New Test Menu',
      create_date: new Date('2022-01-30 12:35:06.690682'),
      update_date: new Date('2022-01-30 12:35:06.690682'),
      items: [],
      assets: [asset],
      sections: [],
    },
  ],
};

export const newSectionResponse = {
  type: 'sections',
  data: [
    {
      section_id: 'new-section',
      name: 'new section',
      items: [hotdog.item_id],
      create_date: new Date('2022-03-30 12:35:06.690682'),
      update_date: new Date('2022-03-30 12:35:06.690682'),
      create_user_id: 'abcde',
      update_user_id: 'abcde',
    },
  ],
};

export const extensionsResponse = {
  type: 'extensions',
  data: [
    {
      id: 'extension-1',
      authentication: null,
      addon: {
        id: 'addon-1',
        name: 'Channel One Connector',
        external_system: {
          id: 'uuid-string-channel-1',
          name: 'string',
          integration_type_name: 'Delivery Service',
        },
      },
      instances: [{ id: 'instance-1', name: 'Channel One', settings: {}, endpoints: [] }],
    },
    {
      id: 'extension-2',
      authentication: null,
      addon: {
        id: 'addon-2',
        name: 'Channel Two Connector',
        external_system: {
          id: 'uuid-string-channel-2',
          name: 'string 2',
          integration_type_name: 'Delivery Service',
        },
      },
      instances: [{ id: 'instance-2', name: 'Channel Two', settings: {}, endpoints: [] }],
    },
  ],
};

export const inventoryResponse: IInventoryResponseBody = {
  type: 'recipes',
  data: [
    {
      recipe_id: 'uuid-string',
      name: 'test 1',
      type: 'RECIPE',
      description: 'string',
      is_vegan: false,
      is_vegetarian: false,
      contains_alcohol: false,
      nutritional_information: [
        {
          nutrition_id: 'uuid nutrition string',
          name: 'string',
          value_high: 20,
          value_low: 20,
        },
      ],
      allergens_information: [
        {
          allergen_id: 'uuid allergen string',
          name: 'string',
          child_allergens: null,
        },
      ],
      create_date: new Date('2022-03-30 12:35:06.690682'),
      update_date: new Date('2022-03-30 12:35:06.690682'),
      create_user_id: 'abcde',
      update_user_id: 'abcde',
    },
  ],
  paging: { next: null },
};

export const menuWithSections = {
  type: 'menus',
  data: [
    {
      menu_id: 'summer-menu',
      name: 'Summer Menu',
      consumer_name: 'New Menu',
      description: 'string',
      seo_description: 'string',
      create_date: new Date('2022-03-30 12:35:06.690682'),
      update_date: new Date('2022-03-30 12:35:06.690682'),
      create_user_id: 'abcde',
      update_user_id: 'abcde',
      assets: [],
      sections: [
        {
          section_id: 'uuid-string',
          name: 'string',
          create_date: new Date('2022-03-30 12:35:06.690682'),
          update_date: new Date('2022-03-30 12:35:06.690682'),
          create_user_id: 'abcde',
          update_user_id: 'abcde',
          items: [burger],
        },
        {
          section_id: 'hotmains-id',
          name: 'Hot Mains',
          create_date: new Date('2022-03-30 12:35:06.690682'),
          update_date: new Date('2022-03-30 12:35:06.690682'),
          create_user_id: 'abcde',
          update_user_id: 'abcde',
          items: [],
        },
      ],
      items: [hotdog],
    },
  ],
};

export const menuObject = {
  type: 'menu',
  data: [
    Object.assign({}, menu, { menu_id: 'summer-menu' }),
    Object.assign({}, menu, { menu_id: 'uuid-string-2', create_date: '2019-03-26 12:35:06.690682' }),
    Object.assign({}, menu, { menu_id: 'uuid-string-3', create_date: '2022-02-26 12:35:06.690682' }),
  ],
};

export const burgers = {
  item_id: 'burger',
  name: 'Burger',
  consumer_name: 'Delicious Burger',
  description: 'very yummy',
  assets: [asset],
  plu: '111222333',
  recipes: [],
  type: 'STANDARD',
  create_user_id: '00uia83yqD9COeLn6696',
  update_user_id: '00uia83yqD9COeLn6696',
  modifier_groups: [],
  prices: {
    default_base_price_with_tax: 1.5,
    tax_rate: 20,
    price_bands: [],
  },
  tax_rate: 20,
  display_order: 1,
  create_date: '2022-03-30 12:35:06.690682',
  update_date: '2022-03-30 12:35:06.690682',
  ranges: [],
  rules: [],
};

export const ItemsResponseExample = {
  item_id: 'de3ccc32-7a4f-4a36-a5c6-78dc2dea5fc3',
  fk_parent_item_id: null,
  name: 'Example Item',
  consumer_name: 'Example Consumer',
  description: 'This is an example item.',
  plu: '123456789',
  tax_rate: 20,
  is_standalone: true,
  type: 'STANDARD' as TMenuItemType,
  display_order: 1,
  recipe: null,
  assets: [],
  prices: [
    {
      price_id: '33a58af2-4207-48e5-b5d1-3193b0b19838',
      price_band_id: null,
      external_system_id: null,
      value_with_tax: 100,
      tax_rate: 20,
    },
  ],
  ranges: [],
  modifier_groups: [],
  rules: [],
  deposit_return_scheme: 10,
  regulatory_statements: [
    {
      pk_regulatory_statement_id: 'dff10c2e-7193-44eb-97e3-996077498036',
      name: {
        en: 'Regulatory Statement',
      },
      description: {
        en: 'This is a regulatory statement.',
      },
      valid_from: '2022-01-01',
      valid_to: '2022-12-31',
      creation_date: '2022-01-01',
      modification_date: '2022-01-01',
    },
  ],
};

export const oneItem = {
  type: 'items',
  data: [burgers],
};

export const mockLogIn = {
  user: {
    id: 'user_test_id',
    email: 'test@test.com',
    firstName: 'Joe',
    lastName: 'Bloggs',
    emailVerified: true,
  },
  featureFlags: ['deposit_return_scheme'],
};

export const mockPriceSchemeId = 'mock-price-scheme-id';

export const itemsError = {
  status: 'ERROR',
  message: 'Internal Server Error',
} as const;

export const error = {
  status: SnackbarStatus.ERROR,
  message: 'Internal Server Error',
} as const;

export const inventoryError = {
  status: SnackbarStatus.ERROR,
  message: 'Unable to fetch inventory list',
} as const;

export const getInventoryItemError = {
  status: SnackbarStatus.ERROR,
  message: 'Unable to fetch inventory item',
} as const;

export const menusError = {
  status: 'ERROR',
  message: 'Internal Server Error',
} as const;

export const priceBandsError = {
  status: 'ERROR',
  message: 'Internal Server Error',
} as const;

export const channelsVenuesError = {
  status: 'ERROR',
  message: 'Internal Server Error',
} as const;

export const inventoryApiResponse: IInventoryResponseBody = {
  type: 'recipes',
  data: inventoryCsv.map((food, index) => {
    const item: IInventoryItem = { ...inventoryItem };
    item.name = food['Item Name'];
    item.recipe_id = food['Recipe ID'];
    item.is_vegan = food.Vegan;
    item.is_vegetarian = food.Vegetarian;
    if (food.Kcal)
      item.nutritional_information = [
        {
          nutrition_id: 'uuid-kcal',
          name: 'energy',
          value_low: index === 0 ? food.Kcal - 100 : food.Kcal,
          value_high: food.Kcal,
        },
      ];

    item.allergens_information = Object.entries(food)
      .filter(
        ([key, value]) =>
          !['Recipe ID', 'Item Name', 'Kcal', 'Ingredients', 'Vegetarian', 'Vegan'].includes(key) && value,
      )
      .map(([key], idx) => ({
        allergen_id: key,
        name: key,
        child_allergens:
          index === 0 && idx == 0
            ? [
                {
                  allergen_id: key,
                  name: 'child allergen',
                },
              ]
            : null,
      }));
    item.description = food.Ingredients.split(',')
      .map((ingredient) => ingredient.trim().toString())
      .join(', ');
    return item;
  }),
  paging: { next: null },
};

export const SummerMenu = {
  menu_id: 'summer-menu',
  name: 'Summer Menu',
  consumer_name: 'New Menu',
  description: 'No description',
  seo_description: 'No seo description',
  create_date: '2022-04-27T13:39:49.485',
  update_date: '2022-04-28T12:04:39.582',
  create_user_id: '00uia83yqD9COeLn6696',
  update_user_id: '00uia83yqD9COeLn6696',
  sections: [
    {
      name: 'Hot Mains',
      section_id: 'hot-main',
      create_date: '2022-04-28T12:37:37.713',
      update_date: '2022-04-28T12:37:37.713',
      create_user_id: '00uia83yqD9COeLn6696',
      update_user_id: '00uia83yqD9COeLn6696',
      items: [
        {
          name: 'Bibimbap',
          price: 9,
          item_id: 'bibimbap',
          create_date: '2022-04-28T07:01:09.289',
          description: 'Korean bibimbap looks gorgeous on the plate.',
          update_date: '2022-04-28T07:01:09.289',
          create_user_id: '00uia83yqD9COeLn6696',
          update_user_id: '00uia83yqD9COeLn6696',
        },
        {
          name: 'Bulgogi',
          price: 7,
          item_id: 'bulgogi',
          create_date: '2022-04-28T07:02:01.364',
          description: 'Thinly sliced meat that has a smoky-sweet flavor',
          update_date: '2022-04-28T07:02:01.364',
          create_user_id: '00uia83yqD9COeLn6696',
          update_user_id: '00uia83yqD9COeLn6696',
        },
      ],
    },
    {
      name: 'Sides',
      section_id: 'sides',
      create_date: '2022-04-28T12:34:57.217',
      update_date: '2022-04-28T12:34:57.217',
      create_user_id: '00uia83yqD9COeLn6696',
      update_user_id: '00uia83yqD9COeLn6696',
      items: [
        {
          name: 'Mandoo',
          price: 3.5,
          item_id: 'mandoo',
          create_date: '2022-04-28T07:02:45.121',
          description: 'Dumplings',
          update_date: '2022-04-28T07:02:45.121',
          create_user_id: '00uia83yqD9COeLn6696',
          update_user_id: '00uia83yqD9COeLn6696',
        },
        {
          name: 'Kim Chi',
          price: 2.5,
          item_id: 'kim-chi',
          create_date: '2022-04-28T12:34:40.102',
          description: 'Fragrant and Tasty',
          update_date: '2022-04-28T12:34:40.102',
          create_user_id: '00uia83yqD9COeLn6696',
          update_user_id: '00uia83yqD9COeLn6696',
        },
      ],
    },
  ],
  items: [],
};

export const menuSectionReorderResponse = {
  data: [
    { section_id: 'B', display_order: 1 },
    { section_id: 'sectionId', display_order: 2 },
    { section_id: 'c', display_order: 3 },
  ],
};

export const menuSectionNoItems: ISection = {
  sectionId: 'sectionId',
  description: 'description',
  displayOrder: 0,
  name: 'sectionName',
  items: [],
  parentSectionId: null,
};

export const brandsResponse = {
  type: 'brands',
  data: [
    {
      brand_id: '123asd',
      name: 'Ask Italian',
      create_date: '2022-03-30 12:35:06.690682',
      update_date: '2022-03-30 12:35:06.690682',
      create_user_id: 'abcde',
      update_user_id: 'abcde',
    },
    {
      brand_id: '456fgh',
      name: 'Coco di Mama',
      create_date: '2022-03-30 12:35:06.690682',
      update_date: '2022-03-30 12:35:06.690682',
      create_user_id: 'abcde',
      update_user_id: 'abcde',
    },
    {
      brand_id: '789jkl',
      name: 'Pod',
      create_date: '2022-03-30 12:35:06.690682',
      update_date: '2022-03-30 12:35:06.690682',
      create_user_id: 'abcde',
      update_user_id: 'abcde',
    },
    {
      brand_id: '234sdf',
      name: 'Zizzi',
      create_date: '2022-03-30 12:35:06.690682',
      update_date: '2022-03-30 12:35:06.690682',
      create_user_id: 'abcde',
      update_user_id: 'abcde',
    },
  ],
};

export const venuesResponseAPI = {
  type: 'venues',
  data: [
    {
      venue_id: 'uuid string',
      name: 'string',
      phone_number: 'string',
      mobile_number: 'string',
      fax: 'string',
      email: 'string',
      pickup_address: 'string',
      create_date: '2022-03-30 12:35:06.690682',
      update_date: '2022-03-30 12:35:06.690682',
      create_user_id: 'abcde',
      update_user_id: 'abcde',
      price_band: 'price band name',
      assets: [],
      addresses: [],
    },
  ],
};

export const localStorageMock = (function () {
  let store = {};

  return {
    getItem(key) {
      return store[key] || null;
    },

    setItem(key, value) {
      store[key] = value;
    },

    clear() {
      store = {};
    },

    removeItem(key) {
      delete store[key];
    },

    getAll() {
      console.log(store);
    },
  };
})();

export const mockBrandId = '12c41f3c-1a97-4499-a9ff-f498cbfde2a3';
export const mockPriceSchemeUuid = '8c670eb8-12e0-4d1b-aace-b32cd9f8cbd9';

export const mockItemsAPIResponse: IMenuItemsResponseBody = {
  type: 'items',
  data: [
    {
      name: 'Greek Salad',
      type: 'STANDARD',
      asset_url: 'https://azzurri-product-images-dev.s3.eu-west-1.amazonaws.com/63654c4e-dade-4a79-90e9-ca2d9e093a50',
      item_id: '3e310693-59ef-4874-b1f5-5432ddda307a',
      description: 'Healthy salad',
      ranges: [],
    },
    {
      name: "Steve's Gyoza",
      type: 'STANDARD',
      asset_url: null,
      item_id: 'eaef476f-cc15-432a-bf6f-d59e0daa217f',
      description: '45435',
      ranges: [],
    },
    {
      name: 'garlic bread',
      type: 'STANDARD',
      asset_url: null,
      item_id: '6f39c5f7-fdff-46ba-a689-c984fd03b08d',
      description: '12',
      ranges: [],
    },
    {
      name: 'create uncategorised',
      type: 'MODIFIER',
      asset_url: null,
      item_id: 'efcd5e28-5571-416c-bbae-2967bc7d4698',
      description: '12',
      ranges: [],
    },
    {
      name: 'apple pie',
      type: 'STANDARD',
      asset_url: null,
      item_id: 'a0b3c334-efa7-4d50-a1c0-3db8b13e0503',
      description: 'ewr',
      ranges: [],
    },
  ],
  paging: { next: null },
};

export const item1 = {
  type: 'items',
  data: [burgers],
};

export const countries = [
  {
    name: 'Peru',
    alpha3code: 'PER',
  },
];

export const channelPayloadResult = {
  '324324': {
    external_brand_id: null,
    external_id: null,
    pk_venue_external_identifier_id: null,
  },
  '45656645': {
    external_brand_id: null,
    external_id: '67723343334321',
    pk_venue_external_identifier_id: '16235-47723-74843094-2344823',
  },
  '677d0d61-3a11-4df8-8307-752d2af5f704': {
    external_brand_id: '4362831',
    external_id: '6772321',
    pk_venue_external_identifier_id: '16235-47723-74843094-3394823',
  },
};

export const openingTimesPayload: IVenueOpeningTimesRequest = {
  schedules: [
    {
      day_of_week: 'WEDNESDAY',
      end_time: '23:00',
      start_time: '20:30',
    },
  ],
};

export const priceBandsResponse: IGetPriceBandsResponseBody = {
  type: 'price-bands',
  data: [
    {
      price_band_id: '12345',
      name: 'Premium',
      venues: [
        {
          name: 'Stansted',
          venue_id: 'abc',
        },
      ],
    },
  ],
};

export const mockCreateAuthenticatedFetch = (options?: { baseUrl?: string; headers?: HeadersInit }) => {
  const configHeaders =
    options?.headers && !(options.headers instanceof Headers) && !Array.isArray(options.headers) ? options.headers : {};
  return (input: RequestInfo | URL, init?: RequestInit) => {
    const initHeaders =
      init?.headers && !(init.headers instanceof Headers) && !Array.isArray(init.headers) ? init.headers : {};

    return globalThis.fetch(input, {
      ...init,
      headers: {
        ...configHeaders,
        ...initHeaders,
        Authorization: 'Bearer accessToken',
      },
    });
  };
};

export const rangesResponse: IRangesResponseBody = {
  type: 'ranges',
  data: [
    {
      range_id: '12345',
      name: 'Summer Menu',
      description: 'New Menu',
      valid_from: null,
      valid_to: null,
      code: null,
    },
  ],
};
